<template>
  <header
    class="flex justify-between items-center p-4 bg-nucleus-white dark:bg-nucleus-darkBlue"
  >
    <div class="flex items-center">
      <button
        class="block mr-4 cursor-pointer"
        :aria-label="'Go Back to' + name"
        @click="goBack()"
      >
        <span
          class="block align-middle text-3xl text-nucleus-grey dark:text-white icon-arrow-left"
          :title="$t('titles.goBack')"
        ></span>
      </button>
      <div class="font-bold text-nucleus-text">{{ name }}</div>
    </div>
    <!-- <div>
      <DarkToggle></DarkToggle>
    </div> -->
    <!-- <button @click="toggleMenu()" class="block">
      <span
        class="
          block
          align-middle
          text-3xl text-nucleus-grey
          dark:text-white
          icon-kebab
        "
        ></span
      >
    </button> -->
    <div
      v-if="menu"
      v-click-away="toggleMenu"
      class="fixed top-20 left-0 p-2 w-full"
    >
      <div class="bg-nucleus-white shadow-lg">
        <div
          v-if="pageName === 'tenancyDetail'"
          class="p-4 cursor-pointer border-t border-gray-300 text-nucleus-error text-sm"
          @click="deleteTenancyCheck()"
        >
          {{ $t("global.defaults.deleteTenancy") }}
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import DarkToggle from "@/components/global/DarkToggle.vue"; // @ is an alias to /src

@Options({
  props: {
    name: String,
    to: String,
  },
  emits: ["deleteTenancyCheck", "goBack"],
  components: {
    DarkToggle,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    logo() {
      return "logo_black.svg";
    },
    pageName() {
      return this.$route.name;
    },
  },
  methods: {
    toggleMenu() {
      this.menu = this.menu ? false : true;
    },
    deleteTenancyCheck() {
      this.toggleMenu();
      this.$emit("deleteTenancyCheck");
    },
    goBack() {
      this.$emit("goBack");
    },
  },
})
export default class HeaderMini extends Vue {}
</script>
